import React from 'react';

// This component should have a minimum amount of dependencies and should work in every environment
const OutdatedBrowserNotification = () => {
  return (
    <div style={{ padding: '60px 20px', textAlign: 'center' }}>
      The version of this browser is outdated, please update it to the latest version.
    </div>
  );
};

export default OutdatedBrowserNotification;
